import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { HomeDelivery as HomeDeliveryIcon } from './icons';

export const HomeDelivery = styled.div`
  display: flex;
  align-items: center;
  grid-area: 2 / 1 / 3 / 3;
`;

type IconProps = {
  sizeType?: 'small' | 'normal';
};

export const Icon = styled(HomeDeliveryIcon).attrs(props => ({
  color: props.theme.icons.secondary,
}))<IconProps>(
  props => css`
    margin-right: 2px;
    display: flex;

    ${props.sizeType === 'normal' &&
      css`
        margin-right: ${layout.spacing.xSmall};
      `}
  `
);

type TextProps = {
  size?: 'small' | 'normal';
};

export const Text = styled.span<TextProps>(
  props => css`
    color: ${props.theme.text.tertiary};

    ${props.size === 'small' &&
      css`
        font-size: 10px;
      `}

    ${props.size === 'normal' &&
      css`
        font-size: ${layout.fontSizes.small.desktop.rem};
      `}
  `
);
